import React from "react";
import { useLang } from "../i18n/LanguageContext";
import { Reveal } from "../components/Motion";
import Seo from "../components/Seo";
import { LEGAL_CONTENT } from "../i18n/legalContent";

const PAGE_KEY = { impressum: "impressum", privacy: "datenschutz", terms: "agb" };

const Legal = ({ type }) => {
  const { t, lang } = useLang();
  const data = LEGAL_CONTENT[lang][type];
  return (
    <div data-testid={`legal-page-${type}`} className="bg-obsidian">
      <Seo pageKey={PAGE_KEY[type]} />
      <section className="mx-auto max-w-3xl px-6 pt-40 pb-16 md:pt-52">
        <span className="text-xs uppercase tracking-[0.3em] text-champagne">{t.footer.legal}</span>
        <Reveal>
          <h1 className="mt-6 font-serif text-4xl font-light leading-[1.05] tracking-tight text-white md:text-6xl">
            {data.title}
          </h1>
        </Reveal>
      </section>
      <section className="mx-auto max-w-3xl px-6 pb-40">
        <Reveal>
          <div className="whitespace-pre-line border-t border-white/10 pt-12 text-base font-light leading-[1.9] text-white/65">
            {data.body}
          </div>
        </Reveal>
      </section>
    </div>
  );
};

export default Legal;
